export type Ref = string;
export enum RefPrefix {
  Addon = 'add',
  AdminPanel = 'adm',
  Api = 'api', // Our impact API, see docs.ecologi.com
  Discount = 'dis', // Line items with negative value
  Donation = 'don', // Gifting impact to someone else's profile
  FlightCalculator = 'flc',
  ImpactAggregationItem = 'ipa', // Monthly aggregate of charges from impact API
  ImpactShop = 'imp',
  Integration = 'int', // e.g. Shopify
  Subscription = 'sub',
  SubscriptionAddon = 'sua',
}
